import { render, staticRenderFns } from "./imam-hussain.vue?vue&type=template&id=06035b60&"
import script from "./imam-hussain.vue?vue&type=script&lang=ts&"
export * from "./imam-hussain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports